import $ from 'jquery';

/**
 * Auto fill address and city at WC Checkout page
 */
export class WC_Checkout_Autofill {
  constructor() {

    // BILLING
    this.$postcode = $('#billing_postcode');
    this.$huisnummer = $('#billing_address_house_nr');
    this.$toevoeging = $('#billing_address_house_nr_add');
    this.$plaatsnaam = $('#billing_city');
    this.$straatnaam = $('#billing_address_1');
    // SHIPPING
    this.$postcode_shipping = $('#shipping_postcode');
    this.$huisnummer_shipping = $('#shipping_address_house_nr');
    this.$toevoeging_shipping = $('#shipping_address_house_nr_add');
    this.$plaatsnaam_shipping = $('#shipping_city');
    this.$straatnaam_shipping = $('#shipping_address_1');


    this.$toevoeging
      .add(this.$postcode)
      .add(this.$huisnummer)
      .on('blur', () => this.check_billing_info());

    this.$postcode.on('change', () => this.check_billing_info_again());
    this.$huisnummer.on('change', () => this.check_billing_info_again());
    this.$toevoeging.on('change', () => this.check_billing_info_again());


    this.$toevoeging_shipping
      .add(this.$postcode_shipping)
      .add(this.$huisnummer_shipping)
      .on('focusout', () => this.check_shipping_info());

    this.$postcode_shipping.on('change', () => this.check_shipping_info_again());
    this.$huisnummer_shipping.on('change', () => this.check_shipping_info_again());
    this.$toevoeging_shipping.on('change', () => this.check_shipping_info_again());


  }

  /**
   * Check if billing_postcode and billing_address_house_nr are filled and billing_address_1 isn't filled already
   */
  // eslint-disable-next-line max-len
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type,@typescript-eslint/explicit-member-accessibility
  check_billing_info() {
    if ((this.$postcode.val().length > 0 && this.$huisnummer.val().length > 0)
      && (this.$straatnaam.val().length === 0 && this.$plaatsnaam.val().length === 0)) {

      $('.billing-js-address-spinner')
        .html(' <i class="fa-solid fa-circle-notch fa-spin autofill__spinner-icon"></i>');

      return this.add_address(
        this.$postcode.val(),
        this.$huisnummer.val(),
        this.$toevoeging.val()
      )
        .then(data => this.update_address(data))
        // eslint-disable-next-line no-console
        .catch(error => console.log('add_address', error));
    }
  }

  /**
   * Check if shipping_postcode and shipping_address_house_nr are filled and shipping_address_1 isn't filled already
   */
  // eslint-disable-next-line max-len
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type,@typescript-eslint/explicit-member-accessibility
  check_shipping_info() {
    if ((this.$postcode_shipping.val().length > 0 && this.$huisnummer_shipping.val().length > 0)
      && (this.$straatnaam_shipping.val().length === 0 && this.$plaatsnaam_shipping.val().length === 0)) {
      $('.shipping-js-address-spinner')
        .html(' <i class="fa-solid fa-circle-notch fa-spin autofill__spinner-icon"></i>');

      return this.add_address(
        this.$postcode_shipping.val(),
        this.$huisnummer_shipping.val(),
        this.$toevoeging_shipping.val()
      )
        .then(data => this.update_shipping_address(data))
        // eslint-disable-next-line no-console
        .catch(error => console.log('add_shipping_address', error));
    }
  }

  // eslint-disable-next-line max-len
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type,@typescript-eslint/explicit-member-accessibility
  add_address(postal_code, house_number, house_number_postfix) {
    return $.ajax({
      // eslint-disable-next-line no-undef
      url: ajax_link,
      method: 'POST',
      data: {
        action: 'get_address_from_postalcode',
        postal_code: postal_code,
        house_number: house_number,
        house_humber_postfix: house_number_postfix,
        // nonce not required, because this doesn't
        // go via our AJAX controller yet
      },
      dataType: 'json',
    });
  }

  // eslint-disable-next-line max-len
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type,@typescript-eslint/explicit-member-accessibility
  //add_shipping_address(postal_code, house_number, house_number_postfix) {
  //  return $.ajax({
  //    // eslint-disable-next-line no-undef
  //    url: ajax_link,
  //    method: 'POST',
  //    data: {
  //      action: 'get_address_from_postalcode',
  //      postal_code: postal_code,
  //      house_number: house_number,
  //      house_humber_postfix: house_number_postfix,
  //      // nonce not required, because this doesn't
  //      // go via our AJAX controller yet
  //    },
  //    dataType: 'json',
  //  });
  //}

  /**
   * Voeg adres en plaatsnaam toe -> Billing
   */
  // eslint-disable-next-line max-len
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type,@typescript-eslint/explicit-member-accessibility
  update_address(result) {

    if ($('#billing_address_1_field .kg-invalid-msg').length > 0) {
      $('div').remove('.kg-invalid-msg');
      //console.log('Deleted.');
    }
    $('.billing-js-address-spinner .fa-solid').remove();

    if (result.street && result.city) {

      this.$straatnaam.val(result.street);
      this.$plaatsnaam.val(result.city);

      // Dispatch a change to trigger the session save (WC_Checkout.js)
      this.$straatnaam.trigger('change');
      this.$plaatsnaam.trigger('change');

      $('input#billing_address_1, input#billing_city')
        .attr('readonly', 1);

      $('#billing_address_1_field, #billing_city_field')
        .removeClass('woocommerce-invalid woocommerce-invalid-required-field');

    } else {

      $('#billing_address_1_field, #billing_city_field')
        .addClass('woocommerce-invalid woocommerce-invalid-required-field');

      $('input#billing_address_1, input#billing_city')
        .removeAttr('readonly')
        .removeClass('no-outline')
        .addClass('input-active');

      if ($('#billing_address_1_field .kg-invalid-msg').length <= 0) {
        $('#billing_address_1_field').append('<div class="kg-invalid-msg">Geen adres gevonden bij de ingevulde postcode, graag handmatig invullen.</div>');
      }

    }
  }

  /**
   * Voeg adres en plaatsnaam toe -> Shipping
   */
  // eslint-disable-next-line max-len
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type,@typescript-eslint/explicit-member-accessibility
  update_shipping_address(result) {

    if ($('#shipping_address_1_field .kg-invalid-msg').length > 0) {
      $('div').remove('.kg-invalid-msg');
      //console.log('Deleted.');
    }

    $('.shipping-js-address-spinner .fa-solid').remove();

    if (result.street && result.city) {

      this.$straatnaam_shipping.val(result.street);
      this.$plaatsnaam_shipping.val(result.city);

      // Dispatch a change to trigger the session save (WC_Checkout.js)
      this.$straatnaam_shipping.trigger('change');
      this.$plaatsnaam_shipping.trigger('change');

      $('input#shipping_address_1, input#shipping_city')
        .attr('readonly', 1);

      $( '#shipping_address_1_field, #shipping_city_field' )
        .removeClass( 'woocommerce-invalid woocommerce-invalid-required-field' );

    } else {

      $( '#shipping_address_1_field, #shipping_city_field' )
        .addClass('woocommerce-invalid woocommerce-invalid-required-field');

      $('input#shipping_address_1, input#shipping_city')
        .removeAttr('readonly')
        .removeClass('no-outline')
        .addClass('input-active');

      if ($('#shipping_address_1_field .kg-invalid-msg').length <= 0 ) {
        $( '#shipping_address_1_field' ).append('<div class="kg-invalid-msg">Geen adres gevonden bij de ingevulde postcode, graag handmatig invullen.</div>');
      }

    }
  }

  /**
   * Check if billing_postcode and billing_address_house_nr are filled and billing_address_1 isn't filled already
   */
  // eslint-disable-next-line max-len
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type,@typescript-eslint/explicit-member-accessibility
  check_billing_info_again() {

    if ((this.$postcode.val().length > 0 && this.$huisnummer.val().length > 0)) {

      $('.billing-js-address-spinner')
        .html(' <i class="fa fa-circle-o-notch fa-spin autofill__spinner-icon"></i>');

      $('div').remove('.kg-invalid-msg');

      return this.add_address(
        this.$postcode.val(),
        this.$huisnummer.val(),
        this.$toevoeging.val()
      )
        .then(data => this.update_address(data))
        // eslint-disable-next-line no-console
        .catch(
          //error => console.log('add_address', error)
        );
    }

    $('input#billing_address_1, input#billing_city')
      .removeAttr('readonly');
  }

  /**
   * Check if shipping_postcode and shipping_address_house_nr are filled and shipping_address_1 isn't filled already
   */
  // eslint-disable-next-line max-len
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type,@typescript-eslint/explicit-member-accessibility
  check_shipping_info_again() {

    if ((this.$postcode.val().length > 0 && this.$huisnummer.val().length > 0)) {

      $('.shipping-js-address-spinner')
        .html(' <i class="fa fa-circle-o-notch fa-spin autofill__spinner-icon"></i>');

      return this.add_address(
        this.$postcode_shipping.val(),
        this.$huisnummer_shipping.val(),
        this.$toevoeging_shipping.val()
      )
        .then(data => this.update_shipping_address(data))
        // eslint-disable-next-line no-console
        //.catch(error => console.log('add_shipping_address', error))
        ;
    }
    $('input#shipping_address_1, input#shipping_city')
      .removeAttr('readonly');
  }
}
